Vue.component('client-operation-emails', {
	props: ['client-id'],

	data () {
		return {
			loading: false,

			emails: [],

			alert: null
		}
	},

	mounted () {
		this.fetchEmails();
	},

	methods: {
		fetchEmails () {
			this.loading = true;

			axios.get('/api/client-operation-emails', {
				params: {
					client_id: this.clientId
				}
			})
				.then((response) => {
					this.emails = response.data;
					this.loading = false;

					this.handleCheckIfShouldAddRow();
				});
		},

		handleSave () {
			this.loading = true;

			const emails = this.emails.filter(e => e.email.length > 0);

			axios.post('/api/client-operation-emails/save', {
				emails
			}, {
				params: {
					client_id: this.clientId
				}
			})
			.then((response) => {
				this.alert = {
					type: 'success',
					message: 'Settings have been saved'
				};

				this.loading = false;
			})
			.catch((response) => {
				this.alert = response.data;
			});
		},

		handleAddNewRow() {
			this.emails.push({
				first_name: '',
				last_name: '',
				mobile: '',
				email: '',
				receive_invites: 0
			});
		},

		handleCheckIfShouldAddRow() {
			const check = this.emails.filter(e => e.email.length === 0 && e.mobile.length === 0).length;

			if (check === 0) {
				this.handleAddNewRow();
			}
		},

		handleDeleteRow(key) {
			this.emails.splice(key, 1);

			this.handleCheckIfShouldAddRow();
		},
	}
});
